import { useContext, useState } from "react";
import { getSortedCollection, matchQuery } from "sprint-common-web";

import { LanguageSpecificationDashboardContext } from "../../context/LanguageSpecificationDashboardContext";
import { LanguageCodeMappingItem } from "../../LanguageSpecificationDashboardItem";
import { MappingListingFilters } from "./useMappingListingFilters";

export const useMappingsListing = () => {
    const [items, setItems] = useState<LanguageCodeMappingItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { languageSpecificationDashboardItem, isLoading } = useContext(LanguageSpecificationDashboardContext);
    const { mappings } = languageSpecificationDashboardItem;

    const saveData = (filters: MappingListingFilters): void => {
        const filteredItems = mappings.filter((item: LanguageCodeMappingItem) =>
            matchQuery(item.languageName, filters.name)
        );

        const sortedAndFilteredItems = getSortedCollection(filteredItems, filters.sortBy, filters.sortOrder);

        setTotalItems(sortedAndFilteredItems.length);
        setItems(sortedAndFilteredItems);
    };

    return {
        items,
        allItems: mappings,
        totalItems,
        isLoading,
        saveData
    };
};
